export const getCampaignList = state => {
    return state.list
}

export const getCampaignDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/campaign/getters.js